import Component from './Component';
// import 'jquery-sticky';

export default class ShareButton extends Component {
	load() {
		this.initShareButton();
		// this.isStuck = false;
		// this.stickyEnabled = false;

		// if (this.doEvents('enable-sticky', false)) {
		// 	this.sticky = document.getElementById('sticky-wrapper');
		// 	// this.$sticky = $(this.sticky);
		// 	// this.initSticky();
		// 	// this.initFadeoutBehindFullWidthSections();
		// }

		super.load();
	}

	initShareButton() {
		$('.share-button__opener').on('click', (e) => {
      // console.log(e);
	  e.stopPropagation();
      let parent = e.target.parentElement;
      // console.log('parent el:', parent);
      // .share-button__container
			this.toggleShare(parent);
		});

	// Close share if the background overlay area is clicked
	$('body').on('click', (e) => {
		const isClickOnShareButtonOpener = e.target.closest('.share-button__opener');
		if (!isClickOnShareButtonOpener) {
			this.closeShare();
		}
	});

    // legacy code for product pages
		// $('html').on('click', 'body.share-open .share-button__wrapper', (e) => {
    //   console.log('product page share button');
		// 	if ($(e.target).hasClass('share-button__wrapper')) {
		// 		this.toggleShare();
		// 	}
		// });

		// $('#share-button-clipboard').click(function() {
		//  const fullUrl = window.location.href;
		// 	var copyText = document.getElementById("myInput");

		// 	copyText.select();
		// 	copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		// 	/* Copy the text inside the text field */
		// 	document.execCommand("copy");
		// });
	}

	// initSticky() {
	// 	$(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
	// 		if (!this.stickyEnabled) {
	// 			const bottom = document.body.clientHeight - ($('.main').offset().top + $('.main').outerHeight());

	// 			this.$sticky.sticky({ bottomSpacing: bottom, zIndex: 1 });
	// 			this.stickyEnabled = true;
	// 		} else {
	// 			this.$sticky.sticky('update');
	// 		}
	// 	}));

	// 	this.$sticky.on('sticky-start sticky-bottom-unreached', () => this.isStuck = true);
	// 	this.$sticky.on('sticky-end sticky-bottom-reached', () => this.isStuck = false);
	// }

	// initFadeoutBehindFullWidthSections() {
	// 	const fullWidthSections = [].slice.call(document.querySelectorAll('.main .full-width'));
	// 	let width = $(window).width();

	// 	$(window).on('resize', () => {
	// 		width = $(window).width();
	// 	});

	// 	$(window).on('scroll resize', window.requestAnimationFrame.bind(window, () => {
	// 		// Immediately exit if we don't meet the requirements
	// 		if (!(this.isStuck && fullWidthSections && width >= 992)) return;

	// 		const stickyRect = this.sticky.getClientRects()[0];
	// 		const intersectingSections = fullWidthSections.filter((el) => {
	// 			let elRect = el.getClientRects()[0];
	// 			elRect = { // Add "padding" to intersection target
	// 			top: elRect.top - 20,
	// 			bottom: elRect.bottom + 20,
	// 		};

	// 		return (
	// 			(elRect.top < stickyRect.bottom && elRect.bottom > stickyRect.bottom) ||
	// 			(elRect.bottom > stickyRect.top && elRect.bottom < stickyRect.bottom)
	// 			);
	// 		});

	// 		if (intersectingSections.length > 0) {
	// 			this.$sticky.addClass('hidden');
	// 		} else {
	// 			this.$sticky.removeClass('hidden');
	// 		}
	// 	}));
	// }

	toggleShare(parent) {
		$('body').toggleClass('share-open');  // grey out rest of page if .share-button__wrapper exists.
    if (!!parent) {
      console.log('parent:', parent);
      parent.querySelector('.share-button__list').classList.toggle('share-button__list--open');
    }
		// $('.share-button__list').toggleClass('share-button__list--open');
	}

	closeShare() {
		$('body').removeClass('share-open');
		const el = document.querySelector('.share-button__list');
		if (el) el.classList.remove('share-button__list--open');
	}
}
